const values = {
    "NO_CLOSURES_TITLE": "No hay registros de cierre en el período de facturación!!!",
    "NO_CLOSURES_SUBTITLE": "Probablemente el periodo de facturación no esté cerrado",
}

export default values;